<!-- 商品分类 -->

<template>
  <div class="discountManaEdit">
    <div class="back">
      <!-- <span @click.stop="$router.back(-1)">返回</span> -->
      <span class="right">
        <!-- <el-button type="primary" @click.stop="save">保存</el-button> -->
      </span>
    </div>
    <div class="item-info">
      <el-form
        :label-position="labelPosition"
        label-width="auto"
        :model="secondInfo"
      >
        <!-- <div> -->
        <el-form-item required label="优惠名称">
          <el-input v-model="secondInfo.name"></el-input>
        </el-form-item>
        <el-form-item required label="优惠方式">
          <el-radio-group v-model="secondInfo.type">
            <el-radio :label="'discount'">打折</el-radio>
            <el-radio :label="'reduce'">减免金额</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          required
          label="折扣"
          v-if="secondInfo.type == 'discount'"
        >
          <el-input v-model="secondInfo.discount"></el-input>折
        </el-form-item>
        <el-form-item
          required
          label="减免金额"
          v-if="secondInfo.type == 'reduce'"
        >
          <el-input v-model="secondInfo.reduceAmount"></el-input>元
        </el-form-item>
        <el-form-item label="生效时间">
          <el-radio-group v-model="secondInfo.timeEnableType">
            <el-radio :label="'custom'">自定义时间</el-radio>
            <el-radio :label="'forever'">永久有效</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          required
          label="请选择时间"
          v-if="secondInfo.timeEnableType == 'custom'"
        >
          <el-date-picker
            :picker-options="pickerOptions"
            v-model="secondInfo.timeForAuto"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item required label="请选择时间范围">
          <el-time-picker
            is-range
            v-model="secondInfo.timeRange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
          >
          </el-time-picker>
        </el-form-item>
        <el-form-item label="星期选择">
          <el-checkbox v-model="isAllWeek" @change="handleChangeWeeksAll">全选</el-checkbox>
          <el-checkbox-group
            v-model="secondInfo.week"
            @change="handleChangeWeeks"
          >
            <el-checkbox
              v-for="weekItem in weeks"
              :label="weekItem"
              :key="weekItem"
              >{{ weekItem }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <!-- </div> -->
      </el-form>
    </div>
    <p style="margin-bottom: 10px; color: red; width: 50%" class="clearfix">
      <el-button style="float: right" type="primary" @click.stop="submit"
        >保存</el-button
      >
    </p>
    <div class="select-wrap" style="width: 100%">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <!-- <el-form-item label="搜索">
          <el-input v-model="searchVal"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="商品分类">
          <el-select v-model="curSelType" placeholder="请选择">
            <el-option :key="-1" :label="'全部'" :value="''">全部</el-option>
            <el-option
              v-for="(item,index) in types"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>-->
        <!-- <el-form-item label="搜索">
          <el-input v-model="searchVal"></el-input>
        </el-form-item>-->
        <!-- <el-button style="float:right" type="primary" @click.stop="save">保存</el-button> -->
      </el-form>
    </div>
    <div class="goods-cont">
      <div class="goods-left">
        <p class="tit">商品选择</p>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          :row-key="getRowKeys"
          @select="toggleSelection"
          @select-all="toggleSelectionAll"
        >
          <el-table-column
            type="selection"
            width="55"
            :reserve-selection="true"
          ></el-table-column>
          <el-table-column label="商品名">
            <template slot-scope="scope">{{ scope.row.name }}</template>
          </el-table-column>
          <el-table-column
            prop="salesPrice"
            label="价格"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="提成">
            <template slot-scope="scope">
              <input type="text" style="width:60px" v-model="scope.row.discountCommission" placeholder="提成金额" />元
            </template>
          </el-table-column>
          <el-table-column
            prop="typeName"
            label="分类"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { url } from "@/router/url.js";
import { BASE_URL } from "../../../../../urlConfig";

export default {
  name: "discountManaEdit",
  props: ["curStoreId"],
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() + 24 * 60 * 60 * 1000 < Date.now();
        },
      },
      isAllWeek:false,
      canClick: true,
      secondInfo: {
        name: "",
        type: "discount",
        discount: "",
        reduceAmount: "",
        timeEnableType: "custom",
        timeForAuto: [],
        timeRange: [],
        week: [],
      },
      tableDataForMeal: [],
      nowPage: 1,
      setMealIds: [],
      size: 1000,
      searchVal: "",
      curSelType: null,
      formInline: {
        user: "",
        region: "",
      },
      levelsList: [], //会员等级列表
      disCoutFirst: [
        {
          id: 0,
          name: "暂无",
        },
        {
          id: 1,
          name: "会员",
        },
        {
          id: 2,
          name: "时间段",
        },
      ],
      labelPosition: "right",
      newDiscount: {
        name: "",
        region: "",
        type: "",
        week: [],
        nowHours: "",
        tomorrowHour: "",
        discountMethod: "",
      },
      weeks: [
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期天",
      ],
      options: [],
      modifyDiscountItem: {},
      tableData: [
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
      ],
      types: [],
      nowSelClassGoods: [],
      multipleSelection: [],
      totalPage: 0,
      totalElements: 0,
    };
  },
  watch: {
    "secondInfo.week"(val){
      if(val.length<this.weeks.length){
        this.isAllWeek = false;
      }else if(val.length==this.weeks.length){
        this.isAllWeek = true;
      }
    },
    curSelType(val) {
      this.nowPage = 1;
      this.getGoods(this.nowPage - 1);
      this.isSearch = false;
    },
    searchVal(val) {
      if (val == "") {
        // this.isSearch = false;
        return;
      }
      //   this.searchGoods();
    },
  },
  methods: {
    handleChangeWeeksAll(val){
      console.log()
      if(this.isAllWeek){
        this.secondInfo.week = this.weeks;
      }else{
        this.secondInfo.week = [];
      }
    },
    checkInfo() {
      if (String(this.secondInfo.name).trim() == "") {
        this.$message({
          message: "请填写名称",
          customClass: "error",
        });
        $(".el-message").css({
          top:"50%"
        });
        return true;
      }
      if (this.secondInfo.type == "reduce") {
        if (this.secondInfo.reduceAmount == "") {
          this.$message({
            message: "请填写金额",
            customClass: "error",
          });
          $(".el-message").css({
          top:"50%"
        });
          return true;
        }
        if (
          !/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(
            this.secondInfo.reduceAmount
          )
        ) {
          this.$message({
            message: "价格格式有误",
            customClass: "error",
          });
          $(".el-message").css({
          top:"50%"
        });
          return true;
        }
      }

      if (this.secondInfo.type == "discount") {
        if (!/^0|[1-9][0-9]*$/.test(this.secondInfo.discount)) {
          this.$message({
            message: "请正确填写折扣",
            customClass: "error",
          });
          $(".el-message").css({
          top:"50%"
        });
          return true;
        }
      }
      if (this.secondInfo.timeEnableType == "custom") {
        if (this.secondInfo.timeForAuto.length == 0) {
          this.$message({
            message: "请选择时间",
            customClass: "error",
          });
          $(".el-message").css({
          top:"50%"
        });
          return true;
        }
      }
      if (this.secondInfo.timeRange.length == 0) {
        this.$message({
          message: "请选择时间范围",
          customClass: "error",
        });
        $(".el-message").css({
          top:"50%"
        });
        return true;
      }
      if (this.secondInfo.week.length == 0) {
        this.$message({
          message: "请选择星期",
          customClass: "error",
        });
        $(".el-message").css({
          top:"50%"
        });
        return true;
      }
      return false;
    },
    submit() {
      if (this.checkInfo()) {
        return;
      }
      console.log(this.secondInfo)
      let data = {
        name: this.secondInfo.name,
        storeId: this.curStoreId,
        discountType: this.secondInfo.type,
        timeType: this.secondInfo.timeEnableType,
        week: this.secondInfo.week.join(),
      };
      let products = [];
      console.log(this.$refs.multipleTable.selection);
      for (let i = 0; i < this.$refs.multipleTable.selection.length; i++) {
        if (
          !/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(
            this.$refs.multipleTable.selection[i].discountCommission
          )
        ) {
          this.$message({
            message: "提成格式有误",
            customClass: "error",
          });
          return true;
        }
        let obj = {
          productId:this.$refs.multipleTable.selection[i].id,
          discountCommission:this.$refs.multipleTable.selection[i].discountCommission * 100,
        }
        products.push(obj);
      }
      if (!products.length) {
        this.$message({
          message: "请选择商品",
          customClass: "error",
        });
        return;
      }
      data = Object.assign(data, {
        products,
      });
      if (this.secondInfo.type == "discount") {
        data = Object.assign(data, {
          discount: this.secondInfo.discount * 10,
        });
      } else if (this.secondInfo.type == "reduce") {
        data = Object.assign(data, {
          reduceAmount: this.secondInfo.reduceAmount * 100,
        });
      }

      if (this.secondInfo.timeEnableType == "custom") {
        console.log(new Date(this.secondInfo.timeRange[0]).getTime());
        console.log(new Date().getTime());
        // if (
        //   new Date(this.secondInfo.timeRange[0]).getTime() <
        //   new Date().getTime()
        // ) {
        //   this.$message({
        //     message: "开始时间不能小于当前时间",
        //     customClass: "error",
        //   });
        //   return;
        // }
        data = Object.assign(data, {
          begin: new Date(this.secondInfo.timeForAuto[0]).Format("yyyy-MM-dd") + " 00:00:00",
          end: new Date(this.secondInfo.timeForAuto[1]).Format("yyyy-MM-dd") + " 23:59:59",
          beginHour: new Date(this.secondInfo.timeRange[0]).Format("hh:mm:ss"),
          endHour: new Date(this.secondInfo.timeRange[1]).Format("hh:mm:ss"),
        });
      } else if (this.secondInfo.timeEnableType == "forever") {
        data = Object.assign(data, {
          beginHour: new Date(this.secondInfo.timeRange[0]).Format("hh:mm:ss"),
          endHour: new Date(this.secondInfo.timeRange[1]).Format("hh:mm:ss"),
        });
      }

      if (!this.canClick) {
        return;
      }
      this.canClick = false;
      this.$http({
        url: "dp/add",
        method: "POST",
        data,
      })
        .then((res) => {
          this.$message({
            message: "操作成功",
            customClass: "success",
          });
          this.secondInfo = {
            name: "",
            type: "discount",
            discount: "",
            reduceAmount: "",
            timeEnableType: "custom",
            timeForAuto: [],
            timeRange: [],
            week: [],
          };
          this.$refs.multipleTable.clearSelection();
          console.log(this.$route.name);
          if(JSON.parse(sessionStorage.getItem("tabNames"))){
              let tabNamesList = JSON.parse(sessionStorage.getItem("tabNames"));
              tabNamesList.forEach((item,index)=>{
                if(item.name == this.$route.name){
                  console.log(item)
                  tabNamesList.splice(index,1);
                }
              })
              sessionStorage.setItem("tabNames",JSON.stringify(tabNamesList));
          }
          this.$router.push({
            name:`second`
          });
          // location.reload()
          setTimeout(() => {
            this.canClick = true;
          }, 1000);
        })
        .catch((err) => {
          setTimeout(() => {
            this.canClick = true;
          }, 1000);
        });
    },
    getRowKeys(row) {
      return row.productId;
    },
    // 新增优惠方式
    check() {
      //正则验证方法
      if (!this.newDiscount.name) {
        this.$message({
          message: "请输入优惠名称",
          customClass: "error",
        });
        return true;
      }
      if (this.newDiscount.discountEnabled) {
        if (this.newDiscount.discountJudgeMethod == 0) {
          this.$message({
            message: "请选择折扣方式，选择会员需确保当前商品有会员折扣",
            customClass: "error",
          });
          return true;
        }
        if (
          this.newDiscount.discountJudgeMethod == 1 &&
          this.newDiscount.discountMethod == 3
        ) {
          this.$message({
            message: "当前商品没有设置会员折扣",
            customClass: "error",
          });
          return true;
        }
        if (!this.newDiscount.disPrice) {
          this.$message({
            message: "请输入折扣百分比",
            customClass: "error",
          });
          return true;
        }
        if (
          !/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(
            this.newDiscount.disPrice
          )
        ) {
          this.$message({
            message: "折扣格式有误",
            customClass: "error",
          });
          return true;
        }
        if (!this.newDiscount.nowHours || !this.newDiscount.tomorrowHour) {
          this.$message({
            message: "折扣时间有误",
            customClass: "error",
          });
          return true;
        }
        if (
          this.newDiscount.nowHours == "aN:aN:aN" ||
          this.newDiscount.tomorrowHour == "aN:aN:aN"
        ) {
          this.$message({
            message: "折扣时间有误",
            customClass: "error",
          });
          return true;
        }
        if (
          new Date(this.newDiscount.nowHours).getTime() >
          new Date(this.newDiscount.tomorrowHour).getTime()
        ) {
          this.$message({
            message: "折扣起始时间应小于截止时间",
            customClass: "error",
          });
          return true;
        }

        if (this.newDiscount.week == "") {
          this.$message({
            message: "请选择星期",
            customClass: "error",
          });
          return true;
        }
      }

      // if (this.multipleSelection.length == 0) {
      //   this.$message({
      //     message: "请选择商品",
      //     customClass: "error",
      //   });
      //   return true;
      // }
      if (this.newDiscount.discountMethod == 2) {
        for (let i = 0; i < this.levelsList.length; i++) {
          if (this.levelsList[i].nowSetPrice != "") {
            if (
              !/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(
                this.levelsList[i].nowSetPrice
              )
            ) {
              this.$message({
                message: "会员另设折扣格式错误",
                customClass: "error",
              });
              return true;
            }
          } else {
            this.$message({
              message: "请填写会员价格",
              customClass: "error",
            });
            return true;
          }
        }
      }
      if (
        !this.newDiscount.discountEnabled &&
        this.newDiscount.discountMethod == 3
      ) {
        this.$message({
          message: "请选择折扣方式",
          customClass: "error",
        });
        return true;
      }
      return false;
    },
    save() {
      if (this.check()) {
        return;
      }
      let productIds = [];
      let setMealIds = [];
      // for (let i = 0; i < this.proIds.length; i++) {
      //   if (this.proIds[i].productId) {
      //     productIds.push(this.proIds[i].productId);
      //   }
      // }

      console.log("seled", this.nowSelClassGoods);
      // return;
      for (let i = 0; i < this.nowSelClassGoods.length; i++) {
        if (this.nowSelClassGoods[i].productId) {
          if (this.nowSelClassGoods[i].setMealId == 0) {
            productIds.push(this.nowSelClassGoods[i].productId);
          }
        }
        if (
          this.nowSelClassGoods[i].setMealId != 0 &&
          this.nowSelClassGoods[i].setMealId
        ) {
          setMealIds.push(this.nowSelClassGoods[i].setMealId);
        }
      }

      let otherPrices = [];
      for (let i = 0; i < this.levelsList.length; i++) {
        if (this.levelsList[i].nowSetPrice != "") {
          let obj = {
            levelName: this.levelsList[i].name,
            levelId: this.levelsList[i].id,
            price: (Number(this.levelsList[i].nowSetPrice) / 100).toFixed(2),
          };
          otherPrices.push(obj);
        }
      }
      this.newDiscount.productIds = productIds;
      this.newDiscount.prices = otherPrices;
      this.$http({
        url: "group-update",
        method: "POST",
        data: {
          groupId: this.newDiscount.groupId,
          storeId: this.curStoreId,
          name: this.newDiscount.name,
          discountMethod: this.newDiscount.discountMethod,
          prices: this.newDiscount.discountMethod == 2 ? otherPrices : null,
          discountEnabled: this.newDiscount.discountEnabled,
          week: this.newDiscount.week.join(),
          discountJudgeMethod: this.newDiscount.discountJudgeMethod,
          nowHours: this.newDiscount.discountEnabled
            ? new Date(this.newDiscount.nowHours).Format("hh:mm:ss")
            : "",
          tomorrowHour: this.newDiscount.discountEnabled
            ? new Date(this.newDiscount.tomorrowHour).Format("hh:mm:ss")
            : "",
          disPrice: this.newDiscount.disPrice,
          productIds,
          setMealIds,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.msg,
            customClass: "success",
          });
          // this.getGoods(0);
          let modifyDiscountItem = JSON.parse(
            sessionStorage.getItem("modifyDiscountItem")
          );
          modifyDiscountItem.goods = this.nowSelClassGoods;
          sessionStorage.setItem(
            "modifyDiscountItem",
            JSON.stringify(modifyDiscountItem)
          );
          // if (this.$route.query.type == "add") {
          //   this.$router.back(-1);
          // } else {
          //   window.location.reload(true);
          // }
          // this.$router.back(-1);
        } else if (res.data.code == 400) {
          this.$message({
            message: res.data.msg,
            customClass: "error",
          });
        }
      });
    },
    handleCurrentChange(val) {
      this.nowPage = val;
      if (this.isSearch) {
        this.searchGoods(this.nowPage - 1);
      } else {
        this.getGoods(this.nowPage - 1);
      }
    },
    // 商品检索
    searchGoods(page = 1) {
      let typeId = this.curSelType ? this.curSelType : "";
      this.nowPage = page;
      this.isSearch = true;
      this.$http({
        url: "products/search",
        params: {
          storeId: this.curStoreId,
          q: this.searchVal,
          typeId: "",
          page: this.nowPage - 1,
          size: 1000,
        },
      }).then((res) => {
        let goodsList = res.data.data;
        for (let i = 0; i < goodsList.length; i++) {
          goodsList[i].count = 0;
          goodsList[i].isChecked = false;
          if (goodsList[i].setMealEnabled) {
            goodsList[i].productId = goodsList[i].setMealId;
          }
        }
        let newGoodsData = [];
        for (let j = 0; j < goodsList.length; j++) {
          let obj = {
            price: goodsList[j].price,
            productId: goodsList[j].productId,
            productName: goodsList[j].productName,
            setMealEnabled: goodsList[j].setMealEnabled,
            setMealId: goodsList[j].setMealId,
            typeId: goodsList[j].typeId,
            typeName: goodsList[j].typeName,
            isChecked: goodsList[j].isChecked,
          };
          newGoodsData.push(obj);
        }
        this.tableData = newGoodsData;
        this.totalPage = res.data.totalPage;
        this.totalElements = res.data.totalElements;
        this.canChangePage = true;
        setTimeout(() => {
          if (this.$route.query.type == "edit") {
            this.filterData();
          }
        }, 250);
      });
    },
    getLevels() {
      this.$http({
        url: "level-list",
        method: "GET",
        params: {
          storeId: this.curStoreId,
        },
      }).then(async (res) => {
        let data = res.data;
        for (let i = 0; i < data.length; i++) {
          data[i].nowSetPrice = "";
        }
        this.levelsList = data;
        if (this.$route.query.type == "edit") {
          let item = JSON.parse(sessionStorage.getItem("modifyDiscountItem"));
          if (item.prices.length > 0) {
            for (let i = 0; i < item.prices.length; i++) {
              for (let j = 0; j < data.length; j++) {
                if (item.prices[i].levelId == data[j].id) {
                  data[j].nowSetPrice = Number(item.prices[i].price) * 100;
                }
              }
            }
          }
          this.levelsList = data;
        }
        await this.getGoods(0);
        await this.getType();
      });
    },
    handleChangeWeeks(value) {
      this.newDiscount.week = value;
    },
    toggleSelectionAll(rows) {
      console.log(rows);
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].isChecked = false;
      }
      rows.forEach((item) => {
        for (let i = 0; i < this.tableData.length; i++) {
          if (item.productId == this.tableData[i].productId) {
            this.tableData[i].isChecked = true;
          }
        }
      });
      let nowSelClassGoods = this.nowSelClassGoods;
      let nowSelIds = [];
      nowSelClassGoods.forEach((item) => {
        nowSelIds.push(item.productId);
      });
      console.log(nowSelClassGoods);
      if (rows.length) {
        for (let i = 0; i < this.tableData.length; i++) {
          let flag = false;
          let index;
          console.log(this.tableData[i]);
          if (this.tableData[i].isChecked) {
            if (nowSelIds.indexOf(this.tableData[i].productId) == -1) {
              nowSelClassGoods.push(this.tableData[i]);
            }
          } else {
            if (nowSelIds.indexOf(this.tableData[i].productId) != -1) {
              for (let j = 0; j < nowSelClassGoods.length; j++) {
                if (
                  nowSelClassGoods[j].productId == this.tableData[i].productId
                ) {
                  flag = true;
                  index = j;
                }
              }
              if (flag) {
                nowSelClassGoods.splice(index, 1);
              }
            }
          }
        }
      } else {
        for (let i = 0; i < this.tableData.length; i++) {
          let flag = false;
          let index;
          this.tableData[i].isChecked = false;
          if (nowSelIds.indexOf(this.tableData[i].productId) != -1) {
            for (let j = 0; j < nowSelClassGoods.length; j++) {
              if (
                nowSelClassGoods[j].productId == this.tableData[i].productId
              ) {
                flag = true;
                index = j;
              }
            }
            if (flag) {
              nowSelClassGoods.splice(index, 1);
            }
          }
        }
      }
      console.log(nowSelClassGoods);
      this.nowSelClassGoods = nowSelClassGoods;
    },
    toggleSelectionAllForMeals(rows) {
      console.log(rows);
      for (let i = 0; i < this.tableDataForMeal.length; i++) {
        this.tableDataForMeal[i].isChecked = false;
      }
      rows.forEach((item) => {
        for (let i = 0; i < this.tableDataForMeal.length; i++) {
          if (item.productId == this.tableDataForMeal[i].productId) {
            this.tableDataForMeal[i].isChecked = true;
          }
        }
      });
      let nowSelClassGoods = this.nowSelClassGoods;
      let nowSelIds = [];
      nowSelClassGoods.forEach((item) => {
        nowSelIds.push(item.productId);
      });
      console.log(nowSelClassGoods);
      if (rows.length) {
        for (let i = 0; i < this.tableDataForMeal.length; i++) {
          let flag = false;
          let index;
          console.log(this.tableDataForMeal[i]);
          if (this.tableDataForMeal[i].isChecked) {
            if (nowSelIds.indexOf(this.tableDataForMeal[i].productId) == -1) {
              nowSelClassGoods.push(this.tableDataForMeal[i]);
            }
          } else {
            if (nowSelIds.indexOf(this.tableDataForMeal[i].productId) != -1) {
              for (let j = 0; j < nowSelClassGoods.length; j++) {
                if (
                  nowSelClassGoods[j].productId ==
                  this.tableDataForMeal[i].productId
                ) {
                  flag = true;
                  index = j;
                }
              }
              if (flag) {
                nowSelClassGoods.splice(index, 1);
              }
            }
          }
        }
      } else {
        for (let i = 0; i < this.tableDataForMeal.length; i++) {
          let flag = false;
          let index;
          this.tableDataForMeal[i].isChecked = false;
          if (nowSelIds.indexOf(this.tableDataForMeal[i].productId) != -1) {
            for (let j = 0; j < nowSelClassGoods.length; j++) {
              if (
                nowSelClassGoods[j].productId ==
                this.tableDataForMeal[i].productId
              ) {
                flag = true;
                index = j;
              }
            }
            if (flag) {
              nowSelClassGoods.splice(index, 1);
            }
          }
        }
      }
      console.log(nowSelClassGoods);
      this.nowSelClassGoods = nowSelClassGoods;
    },
    toggleSelection(selection, rows) {
      rows.isChecked = !rows.isChecked;
      console.log(rows);
      console.log(selection);
      let nowSelClassGoods = this.nowSelClassGoods;
      let flag = false;
      let index = -1;
      for (let i = 0; i < nowSelClassGoods.length; i++) {
        if (nowSelClassGoods[i].productId == rows.productId) {
          flag = true;
          index = i;
        }
      }
      if (flag) {
        nowSelClassGoods.splice(index, 1);
      } else {
        nowSelClassGoods.push(rows);
      }
      this.nowSelClassGoods = nowSelClassGoods;
      selection.forEach((item) => {
        if (item.isChecked) {
          this.$refs.multipleTable.toggleRowSelection(item, true);
          let flag = false;
          let index = -1;
          for (let i = 0; i < nowSelClassGoods.length; i++) {
            if (nowSelClassGoods[i].productId == item.productId) {
              flag = true;
              index = i;
            }
          }
          if (!flag) {
            nowSelClassGoods.push(item);
          }
          this.nowSelClassGoods = nowSelClassGoods;
        } else {
          this.$refs.multipleTable.toggleRowSelection(item, false);
          let flag = false;
          let index = -1;
          for (let i = 0; i < nowSelClassGoods.length; i++) {
            if (nowSelClassGoods[i].productId == item.productId) {
              flag = true;
              index = i;
            }
          }
          if (flag) {
            nowSelClassGoods.splice(index, 1);
          }
          this.nowSelClassGoods = nowSelClassGoods;
        }
      });
    },
    toggleSelectionForMeals(selection, rows) {
      rows.isChecked = !rows.isChecked;
      console.log(rows);
      console.log(selection);
      let nowSelClassGoods = this.nowSelClassGoods;
      let flag = false;
      let index = -1;
      for (let i = 0; i < nowSelClassGoods.length; i++) {
        if (nowSelClassGoods[i].productId == rows.productId) {
          flag = true;
          index = i;
        }
      }
      if (flag) {
        nowSelClassGoods.splice(index, 1);
      } else {
        nowSelClassGoods.push(rows);
      }
      this.nowSelClassGoods = nowSelClassGoods;
      // console.log(nowSelClassGoods)
      selection.forEach((item) => {
        if (item.isChecked) {
          this.$refs.multipleTableForMeals.toggleRowSelection(item, true);
          let flag = false;
          let index = -1;
          for (let i = 0; i < nowSelClassGoods.length; i++) {
            if (nowSelClassGoods[i].productId == item.productId) {
              flag = true;
              index = i;
            }
          }
          if (!flag) {
            nowSelClassGoods.push(item);
          }
          this.nowSelClassGoods = nowSelClassGoods;
        } else {
          this.$refs.multipleTableForMeals.toggleRowSelection(item, false);
          let flag = false;
          let index = -1;
          for (let i = 0; i < nowSelClassGoods.length; i++) {
            if (nowSelClassGoods[i].productId == item.productId) {
              flag = true;
              index = i;
            }
          }
          if (flag) {
            nowSelClassGoods.splice(index, 1);
          }
          this.nowSelClassGoods = nowSelClassGoods;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    filterData() {
      let arr = [];
      for (let j = 0; j < this.nowSelClassGoods.length; j++) {
        for (let i = 0; i < this.tableData.length; i++) {
          if (
            this.tableData[i].productId == this.nowSelClassGoods[j].productId
          ) {
            this.tableData[i].isChecked = true;
            arr.push(this.tableData[i]);
          }
        }
      }
      arr.forEach((item) => {
        this.$refs.multipleTable.toggleRowSelection(item, true);
      });
    },
    filterDataForMeals() {
      let item = JSON.parse(sessionStorage.getItem("modifyDiscountItem"));
      let nowSelClassGoods = [];
      // let proIds = [];
      // let setMealIds = [];
      for (let i = 0; i < item.goods.length; i++) {
        nowSelClassGoods.push({
          price: item.goods[i].price,
          productId: item.goods[i].setMealEnabled
            ? item.goods[i].setMealId
            : item.goods[i].productId,
          productName: item.goods[i].productName,
          typeId: item.goods[i].typeId,
          typeName: item.goods[i].typeName,
          setMealEnabled: item.goods[i].setMealEnabled,
          setMealId: item.goods[i].setMealId,
          isChecked: true,
        });
      }
      this.nowSelClassGoods = nowSelClassGoods;
      let arr = [];
      for (let j = 0; j < this.nowSelClassGoods.length; j++) {
        for (let i = 0; i < this.tableDataForMeal.length; i++) {
          if (
            this.tableDataForMeal[i].productId ==
            this.nowSelClassGoods[j].productId
          ) {
            this.tableDataForMeal[i].isChecked = true;
            arr.push(this.tableDataForMeal[i]);
          }
        }
      }
      arr.forEach((item) => {
        this.$refs.multipleTableForMeals.toggleRowSelection(item, true);
      });
    },
    initInfo() {
      let item = JSON.parse(sessionStorage.getItem("modifyDiscountItem"));
      let nowSelClassGoods = [];
      // let proIds = [];
      // let setMealIds = [];
      for (let i = 0; i < item.goods.length; i++) {
        nowSelClassGoods.push({
          price: item.goods[i].price,
          productId: item.goods[i].setMealEnabled
            ? item.goods[i].setMealId
            : item.goods[i].productId,
          productName: item.goods[i].productName,
          typeId: item.goods[i].typeId,
          typeName: item.goods[i].typeName,
          setMealEnabled: item.goods[i].setMealEnabled,
          setMealId: item.goods[i].setMealId,
          isChecked: true,
        });
      }
      this.nowSelClassGoods = nowSelClassGoods;
      console.log(nowSelClassGoods);
      this.newDiscount = {
        groupId: item.id,
        name: item.name,
        beginTime: "",
        endTime: "",
        discountMethod: item.discountMethod,
        prices: null,
        discountEnabled: item.discountEnabled,
        week: item.week.split(","),
        discountJudgeMethod: item.discountJudgeMethod,
        nowHours: item.nowHours ? new Date("2018-11-11 " + item.nowHours) : "",
        tomorrowHour: item.tomorrowHour
          ? new Date("2018-11-11 " + item.tomorrowHour)
          : "",
        disPrice: item.disPrice, //折扣百分比
        // productIds: productIds, //用户选择的商品id
      };
      let arr = [];
      for (let j = 0; j < nowSelClassGoods.length; j++) {
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].productId == nowSelClassGoods[j].productId) {
            arr.push(this.tableData[i]);
          }
        }
      }

      arr.forEach((item) => {
        this.$refs.multipleTable.toggleRowSelection(item, true);
      });
    },
    // 获取商品
    getGoods(page) {
      this.$http({
        url: "/get-ps",
        method: "GET",
        params: {
          storeId: this.curStoreId,
        },
      }).then((res) => {
        let goodsList = res.data;
        this.tableData = goodsList;
        this.totalPage = res.data.totalPage;
        this.totalElements = res.data.totalElements;
        this.canChangePage = true;
        setTimeout(() => {
          if (this.$route.query.type == "edit") {
            this.filterData();
          }
        }, 250);
      });
    },
    getMeals(typeId) {
      return new Promise((resolve, reject) => {
        this.$http({
          url: "/meal/get-all-ps",
          method: "GET",
          params: {
            storeId: this.curStoreId,
            page: 0,
            size: this.size,
            typeId,
          },
        }).then((res) => {
          let goodsList = res.data.data;
          let newGoodsData = [];
          for (let i = 0; i < goodsList.length; i++) {
            goodsList[i].count = 0;
            goodsList[i].isChecked = false;
            if (goodsList[i].setMealEnabled) {
              goodsList[i].productId = goodsList[i].setMealId;
            }
          }
          for (let j = 0; j < goodsList.length; j++) {
            let obj = {
              price: goodsList[j].price,
              productId: goodsList[j].productId,
              productName: goodsList[j].productName,
              setMealEnabled: goodsList[j].setMealEnabled,
              setMealId: goodsList[j].setMealId,
              typeId: goodsList[j].typeId,
              typeName: goodsList[j].typeName,
              isChecked: goodsList[j].isChecked,
            };
            newGoodsData.push(obj);
          }
          resolve(newGoodsData);
          // this.tableDataForMeal = newGoodsData;
        });
      });
    },
    // 获取商品分类
    getType() {
      this.$http({
        url: "get-type",
        method: "GET",
        params: {
          storeId: this.curStoreId,
        },
      }).then(async (res) => {
        this.types = res.data;
        let funArr = [];
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].setMealEnabled) {
            let fun = this.getMeals(res.data[i].id);
            funArr.push(fun);
          }
        }
        Promise.all(funArr)
          .then((res) => {
            console.log(res);
            let mealsArr = [];
            for (let i = 0; i < res.length; i++) {
              mealsArr = mealsArr.concat(res[i]);
            }
            console.log(mealsArr);
            this.tableDataForMeal = mealsArr;
            setTimeout(() => {
              if (this.$route.query.type == "edit") {
                this.filterDataForMeals();
              }
            }, 250);
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
  },
  activated() {
    this.$refs.multipleTable.clearSelection();
    this.nowPage = 1;
    this.getGoods();
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";

</style>   



// WEBPACK FOOTER //
// index.vue?42076e86